export default __webpack_public_path__ + "static/media/registers.d702f97c.svg";